import cx from 'classnames';
import {
    PREGNANCY_NEWSLETTER,
    PREGNANCY_NEWSLETTER_DESCRIPTION,
    PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR,
    PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_01,
    PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH,
    PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH_01,
    PREGNANCY_WEEKS_BOX_01,
    PREGNANCY_WEEKS_BOX_02,
} from 'mk/autogenerated/translations/PostDetailRight.7333997ea41ceb8ef17eab1a3d3eb14a'
import { hasAds, isAuthenticated } from 'mk/bazaar/common/userUtils';
import { ACTIVE_SERVER_ID } from 'mk/settings';
import SearchPanel from 'mk2/apps/forum/components/SearchPanel';
import { PREGNANCY_WEEKS_URL } from 'mk2/apps/forum/containers/PostDetail/PostDetail';
import {
    ARTICLE_IDS_TO_HIDE_WHEN_PREGNANCY_NEWSLETTER_IS_SHOWN,
} from 'mk2/apps/forum/containers/PostDetail/PostDetail.constants';
import { removeLinesWithLinksToArticle } from 'mk2/apps/forum/containers/PostDetail/PostDetail.helpers';
import { PostDetailViewType, Props } from 'mk2/apps/forum/containers/PostDetail/PostDetailPage';
import {
    PostDetailRelated,
    PostDetailRelatedPlaceholder,
} from 'mk2/apps/forum/containers/PostDetail/PostDetailRelated';
import { forumSearchUrl } from 'mk2/apps/forum/urls';
import { BrandDaysPosts } from 'mk2/apps/home/components/BrandDaysPosts';
import { pregnancyCalculatorUrl } from 'mk2/apps/wiki/urls';
import { Link } from 'mk2/components/Link';
import { Panel } from 'mk2/components/Panel';
import { PanelHeading } from 'mk2/components/PanelHeading';
import { AdSlot } from 'mk2/containers/AdSlot/AdSlot';
import { LoadingSwitch } from 'mk2/containers/LoadingSwitch/LoadingSwitch';
import PregnancyNewsletter from 'mk2/containers/PregnancyNewsletter/PregnancyNewsletter';
import { url } from 'mk2/helpers/urls';
import React from 'react';
import stylesPostDetail from '../../containers/PostDetail/PostDetail.mscss';
import styles from './PostDetailRight.mscss';

export class PostDetailRight extends React.PureComponent<Props> {

    public render() {
        const { isMobile, similarPosts, recentPosts, loadingState } = this.props;

        return isMobile ? null : (
            <LoadingSwitch
                loadingState={loadingState}
                onLoad={this.load}
                onRenderInit={this.renderInit}
                onRenderSuccess={this.renderSuccess}
                onRenderFailure={this.renderFailure}
                onFailureToast={this.failureToast}
                hasData={(recentPosts && recentPosts.length > 0) || (similarPosts && similarPosts.length > 0)}
            />
        );
    }

    private load = () => {/* nothing to do */};

    private renderInit = () => {
        const { viewType, requestUser } = this.props;
        const isAskAnExpert = viewType === PostDetailViewType.AskAnExpert;
        const isContest = viewType === PostDetailViewType.Contest;

        return (
            <>
                {this.renderSearchBox()}

                {!isContest && this.renderRectangleAd()}

                <PostDetailRelatedPlaceholder
                    isAskAnExpert={isAskAnExpert}
                    isContest={isContest}
                    requestUser={requestUser}
                />
            </>
        );
    };

    private renderSuccess = () => {
        const {
            isMobile, location, requestUser, recentPosts, post, similarPosts, brandDaysCampaign, brandDaysPosts,
            viewType, postCanHavePregnancyNewsletter, userCanHavePregnancyNewsletter, backlinksBox, comments,
        } = this.props;

        const isAskAnExpert = viewType === PostDetailViewType.AskAnExpert;
        const isContest = viewType === PostDetailViewType.Contest;
        const showBrandDays = !!brandDaysCampaign && brandDaysPosts.length > 0 && hasAds(requestUser);

        const pregnancyNewsletterDiv = !isMobile && postCanHavePregnancyNewsletter && userCanHavePregnancyNewsletter ? (
            <Panel className={stylesPostDetail.PostDetail__pregnancyNewsletter}>
                <PanelHeading title={PREGNANCY_NEWSLETTER} />
                <p>{PREGNANCY_NEWSLETTER_DESCRIPTION}</p>
                <div
                    className={cx(
                        stylesPostDetail.PostDetail__pregnancyNewsletter__image,
                        stylesPostDetail[`PostDetail__pregnancyNewsletter__image--${ACTIVE_SERVER_ID}`],
                    )}
                />
                <PregnancyNewsletter
                    formNameKey={`forum-post-${post.slug}-right`}
                    noBorder
                    extraEventProps={{
                        subscribe_source: 'tehu_nl_widget_forum',
                        subscribe_source_app: 'forum',
                        subscribe_source_detail: `forum/${post.topic.slug}/${post.slug}`,
                    }}
                    noPregnancyCalculatorLink
                />
            </Panel>
        ) : null;

        const linkToPregnancyCalculator01: string = isAuthenticated(requestUser)
            ? PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH_01
            : PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_01;
        const linkToPregnancyCalculator02: string = isAuthenticated(requestUser)
            ? PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR_AUTH
            : PREGNANCY_NEWSLETTER_LINK_TO_PREGNANCY_CALCULATOR;

        const pregnancyWeekBox = !isMobile && postCanHavePregnancyNewsletter && (
            <Panel className={stylesPostDetail.PostDetail__pregnancyWeeksBox}>
                <p className={stylesPostDetail.PostDetail__pregnancyWeeksBox__p}>
                    {PREGNANCY_WEEKS_BOX_01}
                    {' '}
                    <Link to={PREGNANCY_WEEKS_URL[ACTIVE_SERVER_ID]}>{PREGNANCY_WEEKS_BOX_02}</Link>
                    {'. '}
                    {linkToPregnancyCalculator01}
                    {' '}
                    <Link to={pregnancyCalculatorUrl}>
                        {linkToPregnancyCalculator02}
                    </Link>
                    {'.'}
                </p>
            </Panel>
        );

        const modifiedBacklinksBox = postCanHavePregnancyNewsletter && userCanHavePregnancyNewsletter
            ? backlinksBox && removeLinesWithLinksToArticle(backlinksBox, ARTICLE_IDS_TO_HIDE_WHEN_PREGNANCY_NEWSLETTER_IS_SHOWN)
            : backlinksBox;

        return (
            <>
                {this.renderSearchBox()}

                {showBrandDays && (
                    <BrandDaysPosts
                        className={styles.PostDetailRight__brandDaysPosts}
                        brandDaysCampaign={brandDaysCampaign}
                        brandDaysPosts={brandDaysPosts}
                    />
                )}

                {!isContest && post && !post.isNoAds && this.renderRectangleAd()}

                {pregnancyNewsletterDiv}
                {pregnancyWeekBox}

                <PostDetailRelated
                    isAskAnExpert={isAskAnExpert}
                    isContest={isContest}
                    isMobile={isMobile}
                    location={location}
                    post={post}
                    comments={comments}
                    requestUser={requestUser}
                    similarPosts={similarPosts}
                    recentPosts={recentPosts}
                    backlinksBox={modifiedBacklinksBox}
                />
            </>
        );
    };

    private renderFailure = () => null; /* nothing to render */

    private failureToast = () => {/* nothing to do */};

    private renderSearchBox = () => {
        const { viewType } = this.props;

        if (viewType === PostDetailViewType.Contest) {
            return null;
        }

        return (
            <SearchPanel
                key="search"
                onSubmit={this.onSearch}
                className={styles.PostDetailRight__searchPanel}
            />
        );
    };

    private renderRectangleAd = () => {
        const { location } = this.props;

        // Chceme aby sa adslot nacital uz pocas loadingu, a tak sme skor zobrazili reklamu.
        // Preto ma rovnaky key="" v renderInit aj v renderSuccess()
        return (
            /*<AdformInview
                key="advertisement"
                placementId={ACTIVE_SERVER_ID === 201 ? 544773 : 402804}
                passback={*/
                    <AdSlot
                        key="advertisement-passback"
                        zone="Forum Thread - Rectangle 1 (Desktop)"
                        location={location}
                        marginBottomWithAd={10}
                    />/*
                }
                marginBottomWithAd={10}
            />*/
        );
    };

    private onSearch = (query: string) => {
        this.props.history.push(url(forumSearchUrl, {}, { q: query }));
    };
}
